////////////////////////////////////////////////////////////
//  Program: TemplateForm.jsx                             //
//  Application:  Template Form                           //
//  Option: List of Template                              //
//  Developer: kiran singh                                //
//  Date: 2022-04-01                                      //
////////////////////////////////////////////////////////////
import React, { Component } from "react";
import { Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import AuditTemplateService from "../../services/AuditTemplateService";
import pluswIcon from "./../../assets/images/plus.svg";
import deleteicon from "../../assets/images/delete-gray.svg";
import EditpenIcon from "./../../assets/images/edit-pen-icon.svg";
import back from "./../../assets/images/back.svg";
import Alerts from "../common/Alerts";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import LinkModal from "../LinkModal";
import exportIcon from "./../../assets/images/export-icon.svg";
import RiskLevelConfig from "../common/RiskLevelConfig";

// import modaldeleteicon from "./../../assets/images/delete.svg";
export class AuditTemplateAdd extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.state = {
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
      loading: false,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      input: {},
      errors: {},
      status_id: true,
      slug: this.props.match.params.slug,
      isSubmit: false,
      isDelete: false,
      sort_order: "",
      pathname: window.location.pathname,
      toggleSwitchDark2: true,
      zoneTypeList: [],
      formValues: [
        {
          category_name: "",
          task_name: [{ task_name: "", task_exclude: "", viewMode: false, weight_score: "" }],
        },
      ],
      showWeightInput: false, // Controls Weight % input visibility
      weightPercentage: "",   // Stores Weight % value
      showTaskCheckbox: false,
      configData: [],
      showRiskLevelInfo: false,
      allowRiskLevelConfig: false, // Allow Risk Level
      riskConfigData: [],
      deleteTaskModal: false,
      pendingDeleteTask: null,
      excludeTaskModal: false,
      pendingExcludeTask: null,
      deleteCategoryModal: false,
      pendingDeleteCategory: null,
    };
    this._modulesCache = {};
    this.quillRefs = [];
    this.saveOrUpdateTemplate = this.saveOrUpdateTemplate.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.opendeleteModal = this.opendeleteModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleModalRemove = this.handleModalRemove.bind(this);
    this.handleChangeQuill = this.handleChangeQuill.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalSubmit = this.handleModalSubmit.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleChangeEdit = this.handleChangeEdit.bind(this);
    this.insPdfGenerator = this.insPdfGenerator.bind(this);
    this.handleWeightChange = this.handleWeightChange.bind(this);
  }

  rowData(data) {
    this.setState({ configData: data });
  }

  handleConfigChange = (data) => {
    this.setState({ configData: data });
  };

  customValidate() {
    let isValid = true;
    return isValid;
  }

  getTitle() {
    if (this.state.slug !== undefined) {
      return "Property Visit Template";
    } else {
      return "Property Visit Template";
    }
  }
  setOpen(open, e) {
    this.setState({ open: open });
    this.setState({ eventKey: e.target.eventKey });
  }
  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    value = event.target.type === "radio" ? parseInt(value) : value;

    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
    // Validate
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };
  /***** handle all category add and remove  */
  handleChange(i, e) {
    let formValues = this.state.formValues;
    formValues[i][e.target.name] = e.target.value;
    this.setState({ formValues });
  }
  addFormFields() {
    this.setState(
      {
        formValues: [
          ...this.state.formValues,
          { category_name: "", task_name: [{ task_name: "", viewMode: true }] },
        ],
      },
      () => {
        // Focus on the first ReactQuill of the newly added category
        const lastCategoryIndex = this.state.formValues.length - 1;
        if (
          this.quillRefs[lastCategoryIndex] &&
          this.quillRefs[lastCategoryIndex][0]
        ) {
          this.quillRefs[lastCategoryIndex][0].getEditor().focus();
        }
      }
    );
  }
  removeFormFields(i) {
    this.setState({ deleteCategoryModal: true, pendingDeleteCategory: i });
  }
  closeDeleteCategoryModal() {
    this.setState({ deleteCategoryModal: false, pendingDeleteCategory: null });
  }
  confirmDeleteCategory() {
    const i = this.state.pendingDeleteCategory;
    if (i === null || i === undefined) {
      this.closeDeleteCategoryModal();
      return;
    }
    let formValues = this.state.formValues;
    formValues.splice(i, 1);
    this.setState({ formValues });
    this.closeDeleteCategoryModal();
  }
  /* handle all task add and remove */
  handleChangeTask(k, f, l) {
    if (l.target.name === "is_exclude" && l.target.checked) {
      this.setState({ excludeTaskModal: true, pendingExcludeTask: { k, f } });
      return;
    }
    let formValues = this.state.formValues;
    if (l.target.name === "is_exclude") {
      formValues[k].task_name[f].is_exclude = l.target.checked;
    } else {
      formValues[k].task_name[f].task_name = l.target.value;
    }
    this.setState({ formValues: formValues });
    // localStorage.setItem("formValues", JSON.stringify(formValues));
  }
  closeExcludeTaskModal() {
    this.setState({ excludeTaskModal: false, pendingExcludeTask: null });
  }
  confirmExcludeTask() {
    const pending = this.state.pendingExcludeTask;
    if (!pending) {
      this.closeExcludeTaskModal();
      return;
    }
    let formValues = this.state.formValues;
    formValues[pending.k].task_name[pending.f].is_exclude = true;
    this.setState({ formValues });
    this.closeExcludeTaskModal();
  }

  handleChangeEdit(index, taskIndex) {
    let formValues = [...this.state.formValues];
    formValues[index].task_name[taskIndex].viewMode = true;
    this.setState({ formValues }, () => {
      if (this.quillRefs[index] && this.quillRefs[index][taskIndex]) {
        this.quillRefs[index][taskIndex].getEditor().focus();
      }
    });
  }
  addFormFieldsTask(k, m) {
    this.setState(
      (prevState) => {
        const formValues = [...prevState.formValues];
        formValues[k].task_name.push({ task_name: "", viewMode: true, weight: "" });
        return { formValues };
      },
      () => {
        // Focus on the newly added ReactQuill editor
        const lastTaskIndex = this.state.formValues[k].task_name.length - 1;
        if (this.quillRefs[k] && this.quillRefs[k][lastTaskIndex]) {
          this.quillRefs[k][lastTaskIndex].focus();
        }
      }
    );
  }

  removeFormFieldsTask(k, m) {
    this.setState({ deleteTaskModal: true, pendingDeleteTask: { k, m } });
  }
  closeDeleteTaskModal() {
    this.setState({ deleteTaskModal: false, pendingDeleteTask: null });
  }
  confirmDeleteTask() {
    const pending = this.state.pendingDeleteTask;
    if (!pending) {
      this.closeDeleteTaskModal();
      return;
    }
    let formValues = this.state.formValues;
    formValues[pending.k].task_name.splice(pending.m, 1);
    this.setState({ formValues });
    this.closeDeleteTaskModal();
  }

   handleWeightChange = (categoryIndex, taskIndex, value) => {
    // Only allow numbers and empty string
    if (value === "" || /^[0-9\b]+$/.test(value)) {
      const numericValue = value === "" ? "" : parseInt(value, 10);
      // Don't allow values > 100
      if (numericValue === "" || numericValue <= 1000) {
        const formValues = [...this.state.formValues];
        formValues[categoryIndex].task_name[taskIndex].weight_score = numericValue;
        this.setState({ formValues });
      }
    }
  };

  async componentDidMount() {
    if (this.state.slug !== undefined) {
      var resData = {};
      var resDatalist = {};
      let res = await AuditTemplateService.getAuditTemplateRowBySlug(this.state.slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        resDatalist = resData.data ? resData.data : {};
        resData.audit_name = resDatalist.audit_name ? resDatalist.audit_name : "";
        resData.description = resDatalist.description ? resDatalist.description : "";
        resData.showWeightInput = resDatalist?.is_enable_weight == 1 ? true : false;
        resData.formValues = resDatalist.category
          ? resDatalist.category.map((category) => ({
              category_name: category.category_name,
              slug : category.slug,
              audit_cate_id: category.audit_cate_id,
              task_name: category.task_name.map((task) => ({
                slug: task.slug,
                task_name: task.task_name,
                is_exclude: task.is_exclude == 1 ? true : false,
                weight_score: task.weight_score || "",
                viewMode: false,
              })),
            }))
            : "";
            resData.status_id = resDatalist.status_id === 1 ? true : false;

          this.setState({riskConfigData : resDatalist?.config_data});
          if(resDatalist?.is_risk_level_enable == 1) {
            resData.allowRiskLevelConfig = true;
            this.setState({showRiskLevelInfo : true});
          }

      }
      this.setState(resData);
      this.setState({ formValues: resData.formValues });
    } else {
      this.setState({
        formValues: [{ category_name: "", task_name: [{ task_name: "" }] }],
      });
      const data = JSON.parse(localStorage.getItem("formValues"));
      if (data) {
        this.setState({ formValues: data });
      }
    }
    this.setState({ zoneTypeList: global.zoneTypeList });
    setTimeout(() => {
      this.quillRefs.forEach((refArray, index) => {
        if (Array.isArray(refArray)) {
          refArray.forEach((ref, taskIndex) => {
            if (ref && ref.getEditor) {
              const quill = ref.getEditor();
              quill
              .getModule("toolbar")
              .addHandler("link", () => this.handleLink(index, taskIndex));
              quill.root.addEventListener("click", this.handleLinkClick);
            }
          });
        }
      });
    }, 100);
  }
  getModules(toolbarId, index, indexes) {
    if (!this._modulesCache[toolbarId]) {
      const self = this;
      this._modulesCache[toolbarId] = {
        toolbar: {
          container: `#${toolbarId}`,
          handlers: {
            link: function (value) {
              if (value) {
                const range = this.quill.getSelection();
                if (range) {
                  self.handleLink(index, indexes);
                }
              } else {
                this.quill.format("link", false);
              }
            },
          },
        },
      };
    }
    return this._modulesCache[toolbarId];
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.currentlyFocusedInput) {
      this.currentlyFocusedInput.focus();
    }
    if (prevState.formValues.length !== this.state.formValues.length) {
      setTimeout(() => {
        this.quillRefs.forEach((refArray, index) => {
          if (Array.isArray(refArray)) {
            refArray.forEach((ref, taskIndex) => {
              if (ref && ref.getEditor) {
                const quill = ref.getEditor();
                quill
                  .getModule("toolbar")
                  .addHandler("link", () => this.handleLink(index, taskIndex));
                quill.root.addEventListener("click", this.handleLinkClick);
              }
            });
          }
        });
      }, 100);
    }
  }

  componentWillUnmount() {
    this.quillRefs.forEach((refArray) => {
      if (Array.isArray(refArray)) {
        refArray.forEach((ref) => {
          if (ref && ref.getEditor) {
            const quill = ref.getEditor();
            quill.root.removeEventListener("click", this.handleLinkClick);
          }
        });
      }
    });
  }

  // componentWillUnmount() {
  //   this.quillRefs.forEach((refArray) => {
  //     if (Array.isArray(refArray)) {
  //       refArray.forEach((ref) => {
  //         if (ref && ref.getEditor) {
  //           const quill = ref.getEditor();
  //           quill.root.removeEventListener("click", this.handleLinkClick);
  //         }
  //       });
  //     }
  //   });
  // }

  handleLink(index, taskIndex) {
    const quill = this.quillRefs[index][taskIndex].getEditor();
    const range = quill.getSelection();
    if (range) {
      this.setState({
        showModal: true,
        range: { index, taskIndex, range },
        url: "",
        text: "",
        isEditing: false,
      });
    }
  }

  handleModalClose() {
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
    });
  }

  handleModalSubmit(url, text) {
    const { range } = this.state;
    if (range && url && text) {
      const { index, taskIndex, range: quillRange } = range;
      const quill = this.quillRefs[index][taskIndex].getEditor();
      if (quill) {
        quill.deleteText(quillRange.index, quillRange.length);
        quill.insertText(quillRange.index, text, "link", url);
        quill.setSelection(range.index + text.length);
        quill.focus();
        quill.setSelection(quillRange.index + text.length);
      }
    }
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
    });
  }

  handleLinkClick(event) {
    if (event.target.tagName === "A") {
      event.preventDefault();
      const { range } = this.state;
      if (range) {
        const { index, taskIndex } = range;
        const quill = this.quillRefs[index][taskIndex].getEditor();
        const quillRange = quill.getSelection();
        const url = event.target.getAttribute("href");
        const text = event.target.innerText;

        // Prevent Quill's tooltip from showing
        quill.blur();
        // quill.focus();

        this.setState({
          showModal: true,
          range: { index, taskIndex, range: quillRange },
          url,
          text,
          isEditing: true,
        });
      }
    }
  }

  handleModalRemove() {
    const quill = this.quillRefs[this.state.range.index].getEditor();
    const textLength = quill.getLength();

    // Get the entire content and iterate over each character
    for (let i = 0; i < textLength; i++) {
      const [link] = quill.getFormat(i, 1).link || [];
      if (link) {
        // Remove the link format only, leaving the text intact
        quill.formatText(i, 1, "link", false);
      }
    }

    this.setState({ showModal: false, url: "", text: "", isEditing: false });
  }

  handleChangeQuill(index, taskIndex, value) {
    const formValues = [...this.state.formValues];
    formValues[index].task_name[taskIndex].task_name = value;
    // this.setState({ formValues });
  }

  saveOrUpdateTemplate = async (e) => {
    e.preventDefault();
    let inputData = {
      audit_name: this.state.audit_name ? this.state.audit_name : "",
      description: this.state.description ? this.state.description : "",
      formValues: this.state.formValues ? this.state.formValues : "",
      status_id: this.state.status_id === true ? 1 : 2,
      is_exclude: this.state.is_exclude ? this.state.is_exclude : "",
      is_enable_weight: this.state.showWeightInput ? this.state.showWeightInput : 0,
      is_risk_level_config: this.state.allowRiskLevelConfig ? this.state.allowRiskLevelConfig : 0,
      configData : this.state.configData,
    };
    if (this.validator.allValid() && this.customValidate()) {
      this.setState({ isSubmit: true });
      if (this.state.slug !== undefined) {
        let res = await AuditTemplateService.updateAuditTemplate(
          this.state.slug,
          inputData
        );
        if (global.successStatus.includes(res.status)) {
          this.setState({
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage: res.message ? res.message : "Success",
          });
          setTimeout(
            () => this.props.history.push("/visit-templates"),
            global.redirect_time
          );
        } else {
          let alertMessage = "";
          if (res.data.result.errorDetail !== null) {
            let errors = {};
            res.data.errorCode = "Validation Failed";
            res.data.result.errorDetail.forEach((item) => {
              errors[item.errorField] = item.errorMessage[0];
              res.data.errorMessage = "";
            });
            this.setState({ errors: errors });
          }
          this.setState({
            showAlertModal: true,
            alertModalType: "error",
            alertModalTitle: res.data.message ? res.data.message : "Error!",
            alertModalMessage:
              alertMessage !== "" ? alertMessage : res.data.message,
          });
        }
      } else {
        let res = await AuditTemplateService.createAuditTemplate(inputData);
        if (global.successStatus.includes(res.status)) {
          this.setState({
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage: res.message ? res.message : "Success",
          });
          setTimeout(
            () => this.props.history.push("/visit-templates"),
            global.redirect_time
          );
        } else {
          let alertMessage = "";
          if (
            res.data.errorCode === "validationFailed" &&
            res.data.errorDetail !== null
          ) {
            let errors = {};
            res.data.errorCode = "Validation Failed";
            res.data.errorDetail.forEach((item) => {
              errors[item.errorField] = item.errorMessage[0];
              res.data.errorMessage = "";
            });
            this.setState({ errors: errors });
          }
          this.setState({
            showAlertModal: true,
            alertModalType: "error",
            alertModalTitle: res.data.message ? res.data.message : "Error!",
            alertModalMessage:
              alertMessage !== "" ? alertMessage : res.data.message,
          });
        }
      }
      this.setState({ isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };
  async deleteChecklist(slug) {
    this.setState({ loading: true, isDelete: true });
    let res = await AuditTemplateService.deleteAuditTemplate(slug);
    if (global.successStatus.includes(res.status)) {
      this.closedeleteModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      setTimeout(
        () => this.props.history.push("/audit-templates"),
        global.redirect_time
      );
    } else {
      this.closedeleteModal();
      let alertMessage = "";
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.message ? res.data.message : "Error!",
        alertModalMessage:
          alertMessage !== "" ? alertMessage : res.data.message,
      });
    }
    this.setState({ loading: false, isDelete: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  closedeleteModal() {
    this.setState({ deleteModal: false });
  }
  opendeleteModal(slug) {
    this.setState({ deleteModal: true });
  }

  handleInputFocus = (event) => {
    if (event.target && event.target.name === "audit_name") {
      this.currentlyFocusedInput = event.target;
    } else if (event.target && event.target.name === "description") {
      this.currentlyFocusedInput = event.target;
    } else if (event.target && event.target.name === "category_name") {
      this.currentlyFocusedInput = event.target;
    } else if (event.target && event.target.name === "weight_score") {
      this.currentlyFocusedInput = event.target;
    }
  };

  modifyTaskName(taskName) {
    // Create a temporary element to manipulate the HTML string
    const tempElement = document.createElement("div");
    tempElement.innerHTML = taskName;

    // Find all links in the element
    const links = tempElement.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });

    // Return the modified HTML
    return tempElement.innerHTML;
  }
  async insPdfGenerator() {
    this.setState({ loading: true });
    var list = [];
    let res = await AuditTemplateService.getAuditTemplatePdfBySlug(this.state.slug);
    if (global.successStatus.includes(res.status)) {
      list = res.data.report["0"] ? res.data.report["0"] : [];
    }
    this.setState({ list: list });
    this.setState({ loading: false });
    window.open(this.state.list.filePath, "_blank");
  }

  render() {
    const quillFormats = [
      ...new Set([...(global.formats || []), "color", "background"]),
    ];
    return (
      <main>
        <div className="container-fluid">
          <div className="row row-xs">
            <div className="col-md-12">
              <div className="dashbaord-pageHeadertitle heading_alignment">
                <h3 className="flex-column">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h3>{this.getTitle()}</h3>
                    <div className="btnNavigate d-flex justify-content-end">
                      <Link
                        to={
                          this.props.history.location.pathname === "/property-visit-template/add"
                            ? "/visit-templates"
                            : "/audit-templates"
                        }
                      >
                        <img src={back} alt="" />
                        Back
                      </Link>
                     
                    </div>
                  </div>
                  <span>All Property Visit Templates</span>
                </h3>
                {this.state.slug !== undefined && (
                  <button
                    onClick={this.insPdfGenerator}
                    className="gf-primary-btn-small-one loader_btn pdf_gen export_pdf_btn btn btn-primary ml-auto"
                  >
                    <img src={exportIcon} alt="" />
                    {this.state.loading ? global.loader : "Export PDF"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="d-flex flex-column">
            <div className="row row-xs mg-t-0 pd-t-0">
              <div className="col-md-12 pl-0 pr-0">
                <Alerts
                  show={this.state.showAlertModal}
                  type={this.state.alertModalType}
                  title={this.state.alertModalTitle}
                  message={this.state.alertModalMessage}
                />
              </div>
              <div className="col-md-12">
                <div className="scrolling-carousel p-0">
                  <div className="dashboardRightcard m-0">
                    <div className="mg-t-0 mg-b-0">
                      <div className="az-content-label titleLable">Info</div>
                      <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70">
                        <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                          <label className="form-label mg-b-5">Template Name</label>
                          <Form.Control
                            onChange={this.changeHandler}
                            autoComplete="off"
                            name="audit_name"
                            value={this.state.audit_name ?? ""}
                            className="form-control max_width_100"
                            type="text"
                            placeholder=""
                            onFocus={(e) => this.handleInputFocus(e)}
                          />
                          {this.state.errors.audit_name ? (
                            <div className="text-danger">
                              {this.state.errors.audit_name}
                            </div>
                          ) : (
                            this.validator.message(
                              "audit_name",
                              this.state.audit_name,
                              "required",
                              { className: "text-danger" }
                            )
                          )}
                        </div>
                      </div>
                      <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70">
                        <div className="col-md-9 col-lg-9 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pr-0">
                          <label className="form-label mg-b-5">
                            Description (Optional)
                          </label>
                          <Form.Control
                            onChange={this.changeHandler}
                            autoComplete="off"
                            name="description"
                            value={this.state.description ?? ""}
                            type="textarea"
                            as="textarea"
                            maxLength="500"
                            placeholder="Type here..."
                            onFocus={(e) => this.handleInputFocus(e)}
                          />
                        </div>
                      </div>
                      <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70">
                        <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                            <div className="task-item pl-2 bg-white">
                              <label className="check_cust audit-temp-checkbox mb-0">
                              <input
                                type="checkbox"
                                checked={this.state.showWeightInput}
                                onChange={() =>
                                  this.setState({ showWeightInput: !this.state.showWeightInput, showRiskLevelInfo:false, allowRiskLevelConfig:false })
                                }
                                 className="form-check-input"
                              />
                              Enable Score
                              <span className="checkmark"></span>
                            </label>

                            {this.state.showWeightInput &&
                              <div className="pd-l-70">
                                <label className="check_cust audit-temp-checkbox mb-0">
                                  <input
                                    type="checkbox"
                                    checked={this.state.allowRiskLevelConfig}
                                    onChange={(e) =>
                                      this.setState({
                                        allowRiskLevelConfig: e.target.checked,
                                        showRiskLevelInfo: e.target.checked,
                                      })
                                    }
                                    className="form-check-input"
                                  />
                                  Enable Risk Level
                                  <span className="checkmark"></span>
                                </label>
                              </div>
                            }
                            </div>
                          </div>

                          {this.state.showRiskLevelInfo &&
                            <div className="col-md-12 col-lg-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                              <RiskLevelConfig onChange={this.handleConfigChange} rowData={this.rowData.bind(this)} riskConfigData={this.state.riskConfigData} />
                            </div>
                          }
                      </div>
                      
                      <hr className="mg-t-30 mg-b-20 pd-t-1 pd-b-3" />
                      <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-30 pd-r-20">
                        <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-0 pd-b-1 pd-r-0 pl-0">
                          <div className="az-content-label titleLable pl-0">
                            <span className="pd-t-10 d-block">Tasks</span>
                          </div>
                        </div>
                        
                      </div>
                      {this.state.formValues.map((element, index) => (
                        <div
                          className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-20"
                          key={index}
                        >
                          <div className="col-md-9 col-lg-9 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-15">
                            <label className="form-label text-left mg-b-5">
                              Category
                            </label>
                            <Form.Control
                              name="category_name"
                              autoComplete="off"
                              className="form-control max_width_100"
                              type="text"
                              onFocus={(e) => this.handleInputFocus(e)}
                              value={element.category_name ?? ""}
                              onChange={(e) => this.handleChange(index, e)}
                            />
                          </div>
                          <div className="col-lg-3 align-items-center d-flex">
                            {global.userPermissions.checkPermission(
                              "template-add"
                            ) &&
                              (this.state.formValues.length > 1 ? (
                                <button
                                  type="button"
                                  className="button deleteCat dust_icon"
                                  onClick={() => this.removeFormFields(index)}
                                >
                                  <img src={deleteicon} alt="Delete" />
                                </button>
                              ) : null)}
                          </div>
                          <div className="col-md-8 col-lg-8 mg-t-5 mg-md-t-0 pd-l-70 pd-r-10">
                            <label className="form-label text-left pd-l-70 mb-0">
                              Task
                            </label>
                          </div>
                          <div className="col-md-1 col-lg-1 mg-t-5 mg-md-t-0 pd-b-1 ">
                            <label className="form-label  mg-b-5 pd-l-20">
                              Exclude
                            </label>
                          </div>
                          {element.task_name !== undefined &&
                            element.task_name.map((el, indexes) => {
                              const toolbarId = `toolbar-${index}-${indexes}`;
                              return (
                                <div
                                  className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-0 w-100"
                                  key={indexes}
                                >
                                  <div className="col-md-8 col-lg-8 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-10">
                                    {el.viewMode === false ? (
                                      <>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: this.modifyTaskName(
                                            el.task_name ? el.task_name : ""
                                          ),
                                        }}
                                        className="task-name-span text_para_inn"
                                        onClick={() =>
                                          this.handleChangeEdit(index, indexes)
                                        }
                                      />
                                       {this.state.showWeightInput ? (
                                          <div className="col-md-12 col-lg-12 mg-t-15 pd-b-1 pd-l-0 pd-r-0">
                                            <label className="form-label mg-b-5">Possible Score</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              name="weight_score"
                                              value={el.weight_score || ""}
                                              onChange={(l) => this.handleWeightChange(index, indexes, l.target.value)}
                                              onKeyDown={(e) => {
                                                e.stopPropagation(); // Stop key events from reaching the editor
                                                // Prevent non-numeric input
                                                if (!/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight/.test(e.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the editor
                                              onFocus={(e) => this.handleInputFocus(e)}
                                              onBlur={(e) => {
                                              // Optional: You can add any validation/sanitization here when leaving field
                                              // For example, set to empty if invalid number
                                              if (e.target.value !== "" && isNaN(parseFloat(e.target.value))) {
                                                const formValues = [...this.state.formValues];
                                                formValues[index].task_name[indexes].weight = "";
                                                this.setState({ formValues });
                                              }
                                            }}
                                            />
                                          </div>
                                        ) : null}
                                        </>
                                    ) : (
                                      <>
                                        <div id={toolbarId}>
                                          <select className="ql-color" />
                                          <button className="ql-bold"></button>
                                          <button className="ql-italic"></button>
                                          <button className="ql-underline"></button>
                                          <button className="ql-link"></button>
                                        </div>
                                        <ReactQuill
                                          ref={(el) => {
                                            if (!this.quillRefs[index])
                                              this.quillRefs[index] = [];
                                            this.quillRefs[index][indexes] = el;
                                          }}
                                          theme="snow"
                                          name="task_name"
                                          value={el.task_name ?? ""}
                                          onChange={(l) =>
                                            this.handleChangeQuill(
                                              index,
                                              indexes,
                                              l
                                            )
                                          }
                                         modules={this.getModules(toolbarId, index, indexes)}
                                          formats={quillFormats}
                                          className="custom_editor_style"
                                        />
                                        {this.state.showModal && (
                                          <LinkModal
                                            onClose={this.handleModalClose}
                                            onSubmit={this.handleModalSubmit}
                                            onRemove={this.handleModalRemove}
                                            url={this.state.url}
                                            text={this.state.text}
                                            isEditing={this.state.isEditing}
                                            showModal={this.state.showModal}
                                          />
                                        )}
                                        {this.state.showWeightInput && (
                                        <div className="col-md-12 col-lg-12 mg-t-15 pd-b-1 pd-l-0 pd-r-0">
                                          <label className="form-label mg-b-5">Possible Score</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="weight_score"
                                            value={el.weight_score || ""}
                                            onChange={(e) => this.handleWeightChange(index, indexes, e.target.value)}
                                            onKeyDown={(e) => {
                                              e.stopPropagation(); // Stop key events from reaching the editor
                                              // Allow numbers, backspace, delete, arrows, tab, and decimal point
                                              if (!/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab|\./.test(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the editor
                                            onFocus={(e) => this.handleInputFocus(e)}
                                            onBlur={(e) => {
                                              // Optional: You can add any validation/sanitization here when leaving field
                                              // For example, set to empty if invalid number
                                              if (e.target.value !== "" && isNaN(parseFloat(e.target.value))) {
                                                const formValues = [...this.state.formValues];
                                                formValues[index].task_name[indexes].weight = "";
                                                this.setState({ formValues });
                                              }
                                            }}
                                          />
                                        </div>
                                      )}
                                      </>
                                    )}
                                  </div>
                                  <div className="col-md-3 col-lg-3 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-t-10 text-left d-flex audit_check_box">
                                    <label className="check_cust audit-temp-checkbox">
                                      <input
                                        type="checkbox"
                                        name="is_exclude"
                                        onChange={(l) =>
                                          this.handleChangeTask(
                                            index,
                                            indexes,
                                            l
                                          )
                                        }
                                        checked={!!el.is_exclude}
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                     <div className="audit-custom-BtnBox">
                                    {global.userPermissions.checkPermission(
                                      "template-add"
                                    ) &&
                                      (indexes ? (
                                        <div className="add_edit_del_box">
                                          <button
                                            type="button"
                                            className="button remove deleteCat  new_btn_add"
                                            onClick={() =>
                                              this.removeFormFieldsTask(
                                                index,
                                                indexes
                                              )
                                            }
                                          >
                                            <img
                                              src={deleteicon}
                                              alt="Delete"
                                            />
                                          </button>
                                          {this.state.slug !== undefined ? (
                                            <button
                                              className="button addCat new_btn_add"
                                              type="button"
                                              onClick={() =>
                                                this.handleChangeEdit(
                                                  index,
                                                  indexes
                                                )
                                              }
                                            >
                                              <img
                                                src={EditpenIcon}
                                                alt="Add"
                                              />{" "}
                                            </button>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      ) : null)}
                                      {global.userPermissions.checkPermission(
                                      "template-add"
                                       ) && indexes  === element.task_name.length - 1  ? (
                                          <button
                                          className="button addCat new_btn_add"
                                          type="button"
                                          onClick={() =>
                                            this.addFormFieldsTask(
                                              index,
                                              indexes
                                            )
                                          }
                                        >
                                          <img src={pluswIcon} alt="Add" />{" "}
                                        </button>
                                        ) : ''}
                                    {global.userPermissions.checkPermission(
                                      "template-add"
                                    ) &&
                                      (indexes ? null : (
                                        <div className="add_btn_fst">
                                          {/* <button
                                            className="button addCat new_btn_add"
                                            type="button"
                                            onClick={() =>
                                              this.addFormFieldsTask(
                                                index,
                                                indexes
                                              )
                                            }
                                          >
                                            <img src={pluswIcon} alt="Add" />{" "}
                                          </button> */}
                                          <button
                                            type="button"
                                            className="button deleteCat new_btn_add"
                                            onClick={() =>
                                              this.removeFormFieldsTask(
                                                index,
                                                indexes
                                              )
                                            }
                                          >
                                            <img
                                              src={deleteicon}
                                              alt="Delete"
                                            />
                                          </button>
                                          {this.state.slug !== undefined ? (
                                            <button
                                              className="button addCat new_btn_add"
                                              type="button"
                                              onClick={() =>
                                                this.handleChangeEdit(
                                                  index,
                                                  indexes
                                                )
                                              }
                                            >
                                              <img
                                                src={EditpenIcon}
                                                alt="Add"
                                              />{" "}
                                            </button>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      ))}
                                      </div>
                                  </div>
                                  {/* <div className="col-lg-3 align-items-center pd-t-10 pd-l-5 pt-l-7"></div> */}
                                </div>
                              );
                            })}
                        </div>
                      ))}

                      <div className="row align-items-basline flex-wrap m-0  pd-b-0 pd-l-70 padding-right-72">
                        <div className="col-md-10 col-lg-10 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70 d-flex align-items-center justify-content-between ">
                          <div className="pd-l-70 excluded_box">
                            <p>
                              {" "}
                              <span className="excluded_icon">!</span> Excluded
                              tasks will not be included in scoring.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-10 col-lg-10 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70 d-flex align-items-center justify-content-between ">
                          <div className="d-flex align-items-center justify-content-start ">
                            <label className="form-label text-left mg-b-0">
                              {this.state.status_id ? "Active" : "Inactive"}{" "}
                            </label>
                            <div
                              className={
                                this.state.status_id
                                  ? "az-toggle on"
                                  : "az-toggle"
                              }
                              onClick={() =>
                                this.setState({
                                  status_id: !this.state.status_id,
                                })
                              }
                            >
                              <span></span>
                            </div>
                            
                          </div>
                          {global.userPermissions.checkPermission(
                                "template-add" 
                              ) && (
                                <button
                                  type="button"
                                  className="gf-btn-lg-stroke float-right mr-3 button "
                                  onClick={() => this.addFormFields()}
                                >
                                  add category
                                </button>
                              )}
                          {/* <button type="button" onClick={this.saveOrUpdateTemplate} className="gf-btn-lg-outline mg-r-5"> + Add Task </button> */}
                        </div>
                      </div>
                      <div className="row row-xs align-items-center flex-wrap m-0 pd-t-30 pd-b-0 pd-l-75">
                        <div className="col-md-9 btnNavigate d-flex align-items-center justify-content-between flex-row flex-wrap-bothBtn p-0">
                          {global.userPermissions.checkPermission(
                            "template-delete"
                          ) &&
                            (this.state.slug !== undefined ? (
                              <button
                                className="detlet-text mg-r-20"
                                type="button"
                                onClick={() => {
                                  this.opendeleteModal(this.state.propertySlug);
                                }}
                              >
                                Delete Template
                              </button>
                            ) : (
                              <span className="invisible">
                                Delete Template
                              </span>
                            ))}

                          <div className="d-flex align-items-center pd-r-40">
                            <Link to="/audit-templates">
                              {" "}
                              <button
                                type="button"
                                className="gf-btn-lg-outline mg-r-7"
                              >
                                {" "}
                                Cancel{" "}
                              </button>
                            </Link>
                            {this.state.slug == undefined &&
                              global.userPermissions.checkPermission(
                                "template-add"
                              ) && (
                                <button
                                  type="button"
                                  onClick={this.saveOrUpdateTemplate}
                                  className="gf-btn-lg-stroke mg-l-2"
                                >
                                  {this.state.isSubmit ? global.loader : "ADD"}
                                </button>
                              )}
                            {this.state.slug !== undefined &&
                              global.userPermissions.checkPermission(
                                "template-update"
                              ) && (
                                <button
                                  type="button"
                                  onClick={this.saveOrUpdateTemplate}
                                  className="gf-btn-lg-stroke mg-l-2"
                                >
                                  {this.state.isSubmit
                                    ? global.loader
                                    : "Update"}
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ht-50"></div>
            </div>
          </div>
        </div>
        <Modal show={this.state.deleteModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              {/* <img src={modaldeleteicon} alt="modal-delete-icon" /> */}
              <h3>Delete Template?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Do you really want to delete this template? This process cannot
                be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closedeleteModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteChecklist(this.state.slug)}
                  disabled={this.state.isDelete ? true : false}
                >
                  {this.state.isDelete ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.deleteCategoryModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <h3>Delete Category?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Are you sure you want to delete this category? All tasks
                under it will also be removed. This process cannot be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteCategoryModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.confirmDeleteCategory()}
                >
                  Delete
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.deleteTaskModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <h3>Delete Task?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Are you sure you want to delete this task? This process cannot
                be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteTaskModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.confirmDeleteTask()}
                >
                  Delete
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.excludeTaskModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <h3>Exclude Task?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Are you sure you want to exclude this task?
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeExcludeTaskModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.confirmExcludeTask()}
                >
                  Exclude
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </main>
    );
  }
}

export default AuditTemplateAdd;
